var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import { PillarAccordion } from './PillarAccordion';
export function Rationale(_ref) {
  var environmentalPillars = _ref.environmentalPillars,
      rationale = _ref.rationale,
      socialPillars = _ref.socialPillars,
      title = _ref.title;
  return __jsx(Section, null, __jsx(S.heading.Title3, {
    as: "h3"
  }, title), rationale && __jsx(S.copy.Text1, {
    as: "p"
  }, rationale), environmentalPillars.length > 0 && __jsx(PillarAccordion, {
    brush: ds.color.LIGHT_GREEN,
    criteria: environmentalPillars.map(function (criterion) {
      return {
        description: criterion.extra.description,
        icon: criterion.extra.icon,
        name: criterion.name,
        slug: criterion.slug
      };
    }),
    pillar: "Environnementaux"
  }), socialPillars.length > 0 && __jsx(PillarAccordion, {
    brush: ds.color.YELLOW,
    criteria: socialPillars.map(function (criterion) {
      return {
        description: criterion.extra.description,
        icon: criterion.extra.icon,
        name: criterion.name,
        slug: criterion.slug
      };
    }),
    pillar: "Sociaux"
  }));
}
var Section = styled.section.withConfig({
  displayName: "Rationale__Section",
  componentId: "sc-1p8tvwh-0"
})(["background-color:", ";margin:0px -20px;padding:30px 20px;margin-top:40px;@media screen and (", "){margin-right:-40px;padding-right:40px;margin-left:-40px;padding-left:40px;}@media screen and (", "){margin-bottom:40px;margin-top:40px;}@media screen and (", "){margin-right:-90px;padding-right:90px;margin-left:-90px;padding-left:90px;}@media screen and (", "){margin-right:-140px;padding-right:140px;margin-left:-140px;padding-left:140px;}", "{margin:0 0 20px;}"], ds.color.SAND_2, ds.breakpoint.MOBILE_L, ds.breakpoint.TABLET, ds.breakpoint.LAPTOP, ds.breakpoint.LAPTOP_L, S.heading.Title3);